export default {
  computed: {
    currentUserCountryIsoCode() {
      return this.profile?.company?.country_iso_code || this.profile?.country_iso_code
    },
    companiesModel() {
      return {
        title: 'Companies',
        endpoint: this.$appConfig.api.baseUrl + 'companies',
        allowNew: false,
        countrize: 'country_iso_code',
        fields: [
          {
            key: 'id',
            sortable: true,
            label: this.$gettext('ID'),
            columnFilter: 'text'
          },
          {
            key: 'status',
            sortable: true,
            label: this.$gettext('Status')
          },
          {
            key: 'name',
            sortable: true,
            label: this.$gettext('Commercial Name/Brand'),
            columnFilter: 'text'
          },
          {
            key: 'business_name',
            sortable: true,
            label: this.$gettext('Business/Fiscal Name')
          },
          {
            key: 'tin',
            label: this.$gettext('TIN')
          },
          {
            key: 'contact_name',
            label: this.$gettext('Contact Name')
          },
          {
            key: 'email',
            label: this.$gettext('Email')
          },
          {
            key: 'phone',
            label: this.$gettext('Phone')
          },
          {
            key: 'address',
            label: this.$gettext('Address')
          }
        ],
        filters: [
          'id',
          'name',
          'business_name',
          'tin',
          'contact_name',
          'email',
          'phone'
        ],
        exclude: [
          'address',
          'logo'
        ]
      }
    },
    carriersModel() {
      return {
        title: 'Carriers',
        endpoint: this.$appConfig.api.baseUrl + 'companies',
        allowNew: true,
        countrize: 'country_iso_code',
        afterCreateAction: (item) => {
          if (window.history.length > 2) {
            this.$router.go(-1)
          } else {
            this.$router.push({name: 'CarriersEdit', params: {id: item.id}})
          }
        },
        // editBottomSlot: () => import('@/components/Companies/EditBottomSlot'),
        fields: [
          {
            key: 'id',
            sortable: true,
            label: this.$gettext('ID'),
            columnFilter: 'text'
          },
          {
            key: 'external_id',
            sortable: true,
            label: this.$gettext('External ID'),
            columnFilter: 'text',
            editable: false,
            forceSend: true
          },
          {
            key: 'status',
            sortable: true,
            label: this.$gettext('Status'),
            editable: false,
            default: 'pending',
            type: 'select',
            options: [
              {
                text: this.$gettext('Pending'),
                value: 'pending'
              },
              {
                text: this.$gettext('Confirmed'),
                value: 'confirmed'
              },
              {
                text: this.$gettext('Rejected'),
                value: 'rejected'
              }
            ]
          },
          {
            key: 'name',
            sortable: true,
            label: this.$gettext('Commercial Name/Brand'),
            type: 'text',
            editable: true
          },
          {
            key: 'business_name',
            sortable: true,
            label: this.$gettext('Business/Fiscal Name'),
            type: 'text',
            editable: true
          },
          {
            key: 'tin',
            hidden: true,
            default: 'Contact Name test',
            editable: true
          },
          {
            key: 'contact_name',
            hidden: true,
            default: 'Contact Name test',
            editable: true
          },
          {
            key: 'email',
            hidden: true,
            default: 'test@email.com',
            editable: true
          },
          {
            key: 'phone',
            hidden: true,
            default: '--',
            editable: true
          },
          {
            key: 'address',
            label: this.$gettext('Address'),
            type: 'textarea',
            editable: true
          },
          {
            key: 'relationship',
            hidden: true,
            default: 'provider',
            editable: true
          },
          {
            key: 'country_iso_code',
            hidden: true,
            default: this.currentUserCountryIsoCode,
            editable: true
          },
          {
            key: 'billing_details',
            hidden: true,
            default: {
              name: 'faked',
              last_name: 'faked',
              phone: 'faked',
              emails: ['faked@faked.com']
            },
            editable: true
          }
        ],
        filters: [
          'id',
          'external_id',
          'name',
          'business_name'
        ],
        exclude: [
          'tin',
          'logo',
          'contact_name',
          'email',
          'phone',
          'relationship',
          'country_iso_code',
          'billing_details'
        ]
      }
    },
    customersModel() {
      return {
        title: 'Customers',
        endpoint: this.$appConfig.api.baseUrl + 'companies',
        allowNew: true,
        countrize: 'country_iso_code',
        afterCreateAction: (item) => {
          if (window.history.length > 2) {
            this.$router.go(-1)
          } else {
            this.$router.push({name: 'CustomersEdit', params: {id: item.id}})
          }
        },
        fields: [
          {
            key: 'id',
            sortable: true,
            label: this.$gettext('ID'),
            columnFilter: 'text'
          },
          {
            key: 'external_id',
            sortable: true,
            label: this.$gettext('External ID'),
            columnFilter: 'text',
            editable: false,
            forceSend: true
          },
          {
            key: 'status',
            sortable: true,
            label: this.$gettext('Status'),
            editable: false,
            default: 'pending',
            type: 'select',
            options: [
              {
                text: this.$gettext('Pending'),
                value: 'pending'
              },
              {
                text: this.$gettext('Confirmed'),
                value: 'confirmed'
              },
              {
                text: this.$gettext('Rejected'),
                value: 'rejected'
              }
            ]
          },
          {
            key: 'name',
            sortable: true,
            label: this.$gettext('Commercial Name/Brand'),
            type: 'text',
            editable: true
          },
          {
            key: 'business_name',
            sortable: true,
            label: this.$gettext('Business/Fiscal Name'),
            type: 'text',
            editable: true
          },
          {
            key: 'tin',
            hidden: true,
            default: 'Contact Name test',
            editable: true
          },
          {
            key: 'contact_name',
            hidden: true,
            default: 'Contact Name test',
            editable: true
          },
          {
            key: 'email',
            hidden: true,
            default: 'test@email.com',
            editable: true
          },
          {
            key: 'phone',
            hidden: true,
            default: '--',
            editable: true
          },
          {
            key: 'address',
            label: this.$gettext('Address'),
            type: 'textarea',
            editable: true
          },
          {
            key: 'relationship',
            hidden: true,
            default: 'client',
            editable: true
          },
          {
            key: 'country_iso_code',
            hidden: true,
            default: this.currentUserCountryIsoCode,
            editable: true
          },
          {
            key: 'billing_details',
            hidden: true,
            default: {
              name: 'faked',
              last_name: 'faked',
              phone: 'faked',
              emails: ['faked@faked.com']
            },
            editable: true
          }
        ],
        filters: [
          'id',
          'external_id',
          'name',
          'business_name'
        ],
        exclude: [
          'tin',
          'logo',
          'contact_name',
          'email',
          'phone',
          'relationship',
          'country_iso_code',
          'billing_details'
        ]
      }
    }
  }
}
